import React, { useEffect, useState } from 'react';
import { Container } from './index.style';
import { Modal } from 'react-bootstrap';
import { InterfaceProps } from './index.types';
import { useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import {
  api,
  deleteNotification,
  deleteUsers,
  getNotifications,
  getRegions,
  getStates,
  getUsers
} from '../../../../services';
import { useDispatch, useSelector } from 'react-redux';
import {
  ADD_NOTIFICATIONS,
  ADD_REGIONS,
  ADD_STATES,
  ADD_USERS,
  RootState
} from '../../../../store';
import trash from '../../../../assets/trashDel.png';
import { ModalEditTrue } from '../../../../components';

const ModalApagar: React.FC<InterfaceProps> = ({ isModal, onHide, id }) => {
  const [isModalErrorDelete, setModalErrorDelete] = useState(false);
  const [isModalSucessoDelete, setModalSucessoDelete] = useState(false);
  const { token } = useSelector((state: RootState) => state.clickState);
  const dispatch = useDispatch();

  return (
    <>
      <Modal
        show={isModal}
        onHide={() => {
          onHide();
        }}
      >
        <Container>
          <img src={trash} alt="Lixeira" />
          <h3>Excluir mensagem agendada</h3>
          <h4>Você tem certeza que deseja excluir esta mensagem agendada?</h4>
          <p>Essa ação não podera ser alterada</p>

          <div>
            <button onClick={onHide}>Não, cancelar</button>
            <button
              onClick={() => {
                deleteNotification(token, id)
                  .catch(erro => {
                    console.warn('(Notification) Erro:', erro.response.data);
                    onHide();
                    setModalErrorDelete(true);
                  })
                  .then(resp => {
                    if (resp != null) {
                      getNotifications(token).then(resposta => {
                        dispatch({
                          type: ADD_NOTIFICATIONS,
                          notifications: resposta
                        });
                      });
                      onHide();
                      setModalSucessoDelete(true);
                    } else {
                      console.warn('(Notification) erro:', resp);
                    }
                  });
              }}
            >
              Sim, mensagem
            </button>
          </div>
        </Container>
      </Modal>

      <Modal
        show={isModalErrorDelete}
        onHide={() => {
          setModalErrorDelete(false);
        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <div>
          <h1>Mensagem agendada</h1>
          <p>Erro ao apagar a mensagem!</p>
        </div>
      </Modal>

      <Modal
        show={isModalSucessoDelete}
        onHide={() => {
          setModalSucessoDelete(false);
        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <ModalEditTrue
          close={() => {
            setModalSucessoDelete(false);
          }}
          title="Mensagem agendada"
          subTitle="Mensagem agendada apagada com sucesso"
        />
      </Modal>
    </>
  );
};

export default ModalApagar;
